import React from 'react'
import Segment from '../../../../atoms/Segment/Segment'
import styles from './FundDistributionFooter.module.scss'
import Valid from '../../../../atoms/Svgs/Valid'
import RadialProgress from '../../../../atoms/RadialProgress/RadialProgress'
import CurrencyText from '../../../../atoms/Typography/CurrencyText/CurrencyText'

interface IFundDistributionFooterProps {
  text: string
  amount: number
  isComplete: boolean
  progress: {
    value: number
    style: 'error' | 'warning' | 'default'
  }
}

const FundDistributionFooter = ({ text, amount, isComplete, progress }: IFundDistributionFooterProps) => {
  const progressColor = () => {
    switch (progress.style) {
      case 'error':
        return '#FF1900'
      case 'warning':
        return '#FF6D21'
      default:
        return 'rgba(0,0,0,.8)'
    }
  }

  return (
    <Segment.Group horizontal>
      <Segment>
        <strong>{text}</strong>
      </Segment>
      <Segment>
        <div className={styles.balance}>
          <span className={styles['balance-amount']}>
            <CurrencyText>{amount}</CurrencyText>
          </span>
          <span className={styles['balance-icon']}>
            {isComplete ? (
              <Valid width="20px" height="20px" />
            ) : (
              <RadialProgress size="20" percentage={progress.value} progressColor={progressColor()} />
            )}
          </span>
        </div>
      </Segment>
    </Segment.Group>
  )
}

export default FundDistributionFooter
